import "./index.scss";

const getClassNameFromProp = (prop, prefix) => (prop ? `${prefix}${prop}` : "");

export const DSButton = ({
  variant = "primary",
  size = "default",
  icon,
  iconPosition = "left",
  children,
  disabled,
  iconOnly,
  customClassName = "",
  ...rest
}) => {
  const hasIcon = !!icon;

  const renderButton = () => (
    <>
      {icon && iconPosition === "left" && (
        <span className="button__icon button__icon--left">{icon}</span>
      )}
      {children && <span className="button__text">{children}</span>}
      {icon && iconPosition === "right" && (
        <span className="button__icon button__icon--right">{icon}</span>
      )}
    </>
  );

  return (
    <button
      className={`button
        ${getClassNameFromProp(variant, "button--")}
        ${getClassNameFromProp(size, "button--")}
        ${hasIcon && !iconOnly ? `button--icon-${iconPosition}` : ""}
        ${customClassName ? customClassName : ""}`}
      disabled={disabled}
      {...rest}
    >
      {iconOnly ? <span className="button__icon">{icon}</span> : renderButton()}
    </button>
  );
};
